<template lang="pug">
  multiselect(
    :value="value"
    :options="IdentificationList"
    placeholder="Type to search"
    label="Desc_en"
    track-by="Desc_en"
    name="code"
    @input="onInput"
    :disabled="disabled"
    :loading="Identification_loading"
    :internalSearch="true"
    @search-change="loadIdentification"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.Desc_en }}
</template>

<script>
import jsonData from './e-invoice/IdentificationTypes.json';
import _ from 'lodash';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            IdentificationList: [],
            Identification_loading: false,
        };
    },
    mounted() {
        this.loadIdentification();
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
        loadIdentification: _.debounce(function(query) {
            this.Identification_loading = true;

            if (query) {
                this.IdentificationList = jsonData.filter(item =>
                    item.Desc_en.toLowerCase().includes(query.toLowerCase()),
                );
            } else {
                this.IdentificationList = jsonData;
            }

            this.Identification_loading = false;
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/eIdentificationSelector.vue